import { render, staticRenderFns } from "./VaroantDialog.vue?vue&type=template&id=257f7249&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./VaroantDialog.vue?vue&type=script&lang=js&"
export * from "./VaroantDialog.vue?vue&type=script&lang=js&"
import style0 from "./VaroantDialog.vue?vue&type=style&index=0&id=257f7249&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257f7249",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('257f7249')) {
      api.createRecord('257f7249', component.options)
    } else {
      api.reload('257f7249', component.options)
    }
    module.hot.accept("./VaroantDialog.vue?vue&type=template&id=257f7249&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&", function () {
      api.rerender('257f7249', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/VaroantDialog.vue"
export default component.exports